const barcode = {
  methods: {
    upc(code) {
      return this.barcodeCheck(code, 12);
    },
    scc(code) {
      return this.barcodeCheck(code, 14);
    },
    barcodeCheck(code, length) {
      if (!code || code.length === 0)
        return true;
      if (code.length !== length)
        return `Must be ${length} digits`;

      length--;
      let odd = 0;
      for (let i = 0; i < length; i += 2)
        odd += parseInt(code.substr(i, 1));
      let even = 0;
      for (let i = 1; i < length; i += 2)
        even += parseInt(code.substr(i, 1));
      let check = 10 - (3*odd+even) % 10;
      if (check == 10)
        check = 0;
      if (check != code.substr(length, 1))
        return 'Invalid';

      return true;
    }
  }
}

export default barcode;